import React from 'react';
import {Flex} from '/app/src/component';

class ModalTemplate extends React.Component {
    render() {
        const bgColor = '#f8f8f8'
        const {children} = this.props
        return (
            <Flex grow>
                <Flex
                width='800px'
                height='550px'
                borderRadius='20px'
                column backgroundColor={bgColor}>
                    {children}
                </Flex>
            </Flex>
        )
    }

}

export default ModalTemplate;



// WEBPACK FOOTER //
// ./src/component/Modal/WelcomeModal/ModalTemplate.js